import {h} from 'ui/Framework';

export default h('svg', {
  width: '49',
  height: '22',
  viewBox: '-1 -1 51 24',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', {
      fill: '#21304A'
    }, [
      h('g', [
        h('path', {
          d: 'M10.061 12.104h2.656v1.609h-2.656v4.367H8.274v-4.367H0v-1.788L7.66 0h2.401v12.104zM8.274 2.068h-.051L1.915 12.104h6.359V2.068zm8.07 19.587h-1.456l1.71-6.001h1.814l-2.069 6zm16.164-20.02h-7.534l-.127 5.592a7.122 7.122 0 0 1 1.238-.307 8.154 8.154 0 0 1 1.264-.102c.852 0 1.635.136 2.35.409.715.272 1.336.66 1.864 1.162a5.204 5.204 0 0 1 1.226 1.8c.289.698.434 1.464.434 2.298 0 .868-.145 1.673-.434 2.413a5.601 5.601 0 0 1-1.226 1.916 5.68 5.68 0 0 1-1.903 1.264c-.74.306-1.553.46-2.438.46-1.311 0-2.418-.299-3.32-.894a5.975 5.975 0 0 1-2.094-2.4l1.66-.741a4.04 4.04 0 0 0 1.468 1.787 3.816 3.816 0 0 0 2.184.664c.612 0 1.178-.106 1.698-.32a3.94 3.94 0 0 0 1.34-.893c.375-.383.669-.838.881-1.366.213-.528.32-1.098.32-1.711 0-.664-.115-1.264-.345-1.8a4.007 4.007 0 0 0-.945-1.367 4.212 4.212 0 0 0-1.417-.868 5.053 5.053 0 0 0-1.788-.306c-.647 0-1.29.09-1.928.268a9.181 9.181 0 0 0-1.826.728L23.29 0h9.218v1.634zm7.814 6.256l.05.05c.273-.204.656-.365 1.15-.484.494-.12.97-.18 1.43-.18.783 0 1.51.137 2.183.41a5.31 5.31 0 0 1 1.75 1.136 5.17 5.17 0 0 1 1.161 1.762c.281.69.422 1.443.422 2.26 0 .851-.145 1.626-.434 2.324a5.075 5.075 0 0 1-1.226 1.787 5.802 5.802 0 0 1-1.864 1.162 6.37 6.37 0 0 1-2.35.421 6.37 6.37 0 0 1-2.349-.421 5.802 5.802 0 0 1-1.864-1.162 5.075 5.075 0 0 1-1.226-1.787c-.29-.698-.434-1.473-.434-2.324 0-.937.162-1.805.485-2.605.324-.8.707-1.566 1.15-2.298L43.283 0h2.12l-5.082 7.89zm-1.762 4.954c0 .596.098 1.145.293 1.647.196.502.473.936.83 1.302.358.366.783.656 1.277.868.494.213 1.039.32 1.634.32.596 0 1.141-.107 1.635-.32.494-.212.92-.502 1.277-.868.357-.366.634-.8.83-1.302a4.497 4.497 0 0 0 .293-1.647c0-.58-.093-1.12-.28-1.622a3.772 3.772 0 0 0-.805-1.302 3.625 3.625 0 0 0-1.277-.856 4.4 4.4 0 0 0-1.673-.306 4.4 4.4 0 0 0-1.672.306c-.502.205-.928.49-1.277.856-.349.366-.617.8-.804 1.302a4.604 4.604 0 0 0-.281 1.622z'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-decimal.es6.js